import { useAuth } from "../modules/auth/hooks/use-auth";
import Container from "@/components/ui/container";
import OnboardingTiles from "@/modules/onboarding/components/onboarding-tiles";

export default function DashboardPage() {
	const { user } = useAuth();

	return (
		<Container className="py-12">
			<div className="mb-8">
				<h2 className="text-2xl font-semibold text-primary mb-2">Welcome{user?.first_name ? `, ${user.first_name}` : ""}! 👋</h2>
				<p className="text-tertiary">Let's get your testimonial collection up and running. Here's what you can do to get started:</p>
			</div>

			<OnboardingTiles />
		</Container>
	);
}
